export default "__VITE_ASSET__IoFJ40dX__"